import { Box, Typography } from '@mui/material';

import type { FactsheetDetails } from '@/features/Factsheet';
import RelatedCodeItem from '@/features/Factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/RelatedCodesTab/RelatedCodeItem';

const RelatedCodesTab = ({
  factsheet,
  openNewTab
}: {
  factsheet: FactsheetDetails;
  openNewTab: (code: string) => void;
}) => {
  const parentCodes = factsheet.parentCodes?.filter(p => (p.status ?? 'Live') === 'Live');
  const childCodes = factsheet.childCodes?.filter(c => (c.status ?? 'Live') === 'Live');

  return (
    <Box
      sx={{
        minWidth: 700
      }}
    >
      <Box>
        <Typography sx={{ fontWeight: 700, pb: 1 }}>Parent Codes</Typography>
        {parentCodes?.length === 0 && <Typography sx={{ pb: 1 }}>None.</Typography>}
        {parentCodes?.map((parentCode, index) => (
          <RelatedCodeItem
            key={parentCode.code + index}
            openNewTab={openNewTab}
            relatedCode={parentCode}
          />
        ))}
      </Box>
      <Box>
        <Typography sx={{ fontWeight: 700, pb: 1 }}>Child Codes</Typography>
        {childCodes?.length === 0 && <Typography sx={{ pb: 1 }}>None.</Typography>}
        {childCodes?.map((childCode, index) => (
          <RelatedCodeItem
            key={childCode.code + index}
            openNewTab={openNewTab}
            relatedCode={childCode}
          />
        ))}
      </Box>
    </Box>
  );
};
export default RelatedCodesTab;
